import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { message, Modal, Space, Switch, Tooltip } from 'antd';
import { PRODUCT } from '../../../../constants/define/translation';
import {
  ProductCatalog,
  ProductCatalogStatus,
  updateProductCatalogRepository,
} from '../../../../repository/mytm/shop-product/shopProductRepository';
import { btnActive } from '../../../../styles';
import { ConfirmAction } from '../../../molecules/confirm/ConfirmAction';
import { ShopStatus } from '../../../../types/shop';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { postLoginRepository } from '../../../../repository/mytm/auth/loginRepository';
import { UserContext } from '../../../../repository/context/userContext';

interface ActionsColumnProps {
  record: ProductCatalog;
  countRecord: number;
  onRefresh: () => void;
}

export default React.memo((props: ActionsColumnProps) => {
  const { t } = useTranslation(PRODUCT);
  const { record, onRefresh, countRecord } = props;
  const userContext = useContext(UserContext);

  const [showHideLoading, setShowHideLoading] = useState(false);

  const onShowHideCard = () => {
    const status =
      record.status === ProductCatalogStatus.ACTIVE ? ProductCatalogStatus.INACTIVE : ProductCatalogStatus.ACTIVE;
    const payload: any = {
      id: record.id,
      country: record.country || 'USA',
      product_id: record?.product_id,
      status,
    };
    if (status === ProductCatalogStatus.ACTIVE && countRecord >= 5) {
      message.error(t('message.error.maxItem'));
      return;
    }

    Modal.confirm({
      title: t('popup.title'),
      okText: t('popup.okBtn'),
      cancelText: t('popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: (
        <ConfirmAction
          textConfirmAction={record.status === ShopStatus.INACTIVE ? t('popup.enable') : t('popup.disable')}
          isConfirmPassword
          textConfirmPassword={t('popup.confirmPassword')}
        />
      ),
      onOk() {
        setShowHideLoading(true);
        const onShowHide = () => {
          updateProductCatalogRepository({ ...payload })
            .then(r => {
              onRefresh();
            })
            .catch(e => {
              message.error(e?.errorMessage);
            })
            .finally(() => {
              setShowHideLoading(false);
            });
        };
        const inputPasswordNode = document.getElementById('inputPasswordForConfirm');
        const password = (inputPasswordNode as any).value;
        if (!userContext.user?.email || userContext.user?.email === '') {
          setShowHideLoading(false);
          message.error(MESSAGE_ERROR.M02);
        } else {
          postLoginRepository({
            email: userContext.user?.email,
            password,
          })
            .then(() => {
              onShowHide();
            })
            .catch((e: any) => {
              setShowHideLoading(false);
              message.error(e?.errorMessage);
            });
        }
      },
    });
  };

  return (
    <StyledContainer>
      <Space size="small">
        <Tooltip
          title={
            record.status === ProductCatalogStatus.INACTIVE ? t('table.tooltip.active') : t('table.tooltip.inactive')
          }
        >
          <Switch
            checked={record.status === ProductCatalogStatus.ACTIVE}
            onChange={onShowHideCard}
            disabled={showHideLoading}
            loading={showHideLoading}
          />
        </Tooltip>
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  ${btnActive}
`;
